import { FormEvent, useContext, useState, useEffect } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import Form from '@rjsf/mui';
import { IChangeEvent } from '@rjsf/core';
import { RJSFSchema, UiSchema, RegistryWidgetsType } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import {useReactFlow, applyNodeChanges} from "@xyflow/react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { NodeDataStoreSelectWidget } from "./components/NodeDataStoreSelectWidget";
import { DefaultFormDialog  } from "./components/DefaultFormDialog";
import { processNodeDelete, processNodeFormSubmit, formSchema, nodeDescription } from "./functions/workflow-hq-create-node-configuration";
import {
    Button
} from '@mui/material';

export const WorkflowHQCreateNodeConfiguration = () => {
    const context: any = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();
    const [formData, setFormData] = useState<any>();

    function handleCloseDialog() {
        context.toggleShowHQCreateModal(false);
    }

    const handleFormSubmit = (data: IChangeEvent, event: FormEvent<any>) : void => {
        console.log(data.formData);
        processNodeFormSubmit(context, data.formData, reactFlowInstance);
        handleCloseDialog();
    }

    function deleteNode() {
        processNodeDelete(context, reactFlowInstance);
        handleCloseDialog();
    }


    const uiSchema: UiSchema = {
        'data_input': {
            'ui:widget': 'NodeDataStoreSelectWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'hq_params',
                    'scraper_pending'
                ]
            }
        },
        'data_management': {
            'ui:widget': 'NodeDataStoreSelectWidget',
            'ui:options': {
                'classNames': 'data-management',
                enumDisabled: [
                    'hq_params',
                    'scraper_pending'
                ]
            }
        },
        'ui:order': [ 'data_input', 'entity_or_action', 'entity_data', 'custom_action', 'add_output_to_message',  'data_management' ]
    }

    const widgets: RegistryWidgetsType = {
        NodeDataStoreSelectWidget: NodeDataStoreSelectWidget
    }

    useEffect( (): void => {
        if (context.activeEditHQCreateNode !== undefined && context.activeEditHQCreateNode.data !== undefined) {
            setFormData(context.activeEditHQCreateNode.data);
        }
    } , [context] );



    return (
        <DefaultFormDialog
            open={ context.showHQCreateModal }
            title={ "HQ Create Data Node" }
            handleClose={ handleCloseDialog }
            description={ nodeDescription }
        >
            <span style={ { paddingLeft: '15px', fontWeight: 'bold' } }>{ "Node ID: " + context?.activeEditHQCreateNode?.id }</span>
            <Form
                validator={validator}
                schema={ formSchema }
                uiSchema={ uiSchema }
                onSubmit={ handleFormSubmit }
                widgets={ widgets }
                id="workflow-scraper-node-configure"
                formData={ formData }
                formContext={ formData }
                onChange={({ formData }) => setFormData(formData)}
            >
                <div className="dialog__actions form-group">
                    <Button type="submit"
                            variant="contained"
                            color="success"
                    >
                        <SaveIcon />
                        <span>{ "Save" }</span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ deleteNode }
                        type="button">
                        <DeleteIcon />
                        <span>{ "Delete" }</span>
                    </Button>
                </div>
            </Form>
        </DefaultFormDialog>
    );
}